import React from "react";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import { AgencySubscriptionItemDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { openStripe } from "@src/features/admin/components/utils";

interface MeterLabelProps {
  item: AgencySubscriptionItemDto;
}

export const MeterLabel = ({ item }: MeterLabelProps) => {
  if (item.meter.meter) {
    return (
      <Grid item>
        <IgTypography>
          <IgTypography variant={"body2"} sx={{ fontWeight: 600 }}>
            Meter:{" "}
          </IgTypography>
          <IgLink
            variant={"body2"}
            onClick={() => openStripe(`meters/${item.meter.meter!.id}`)}
          >
            {item.meter.meter.display_name}
          </IgLink>
        </IgTypography>
      </Grid>
    );
  }

  return null;
};
